function checkCookie() {
    if (!document.querySelector('.js-cookie') || getCookie('cookie_accept') === 'true') return;

    setTimeout(showCookiePopup, 5000);

    function showCookiePopup() {
        const cookie = document.querySelector('.js-cookie');

        cookie.addEventListener('click', (e) => {
            const target = e.target;

            if (target.closest('.js-cookie-accept')) {
                setCookie('cookie_accept', 'true');
                cookie.classList.remove('active');
            } else if (target.closest('.js-cookie-close')) {
                cookie.classList.remove('active');
            }
        })

        cookie.classList.add('active');
    }
}
